import { InjectionToken } from '@angular/core';

import { LayoutId } from './layout.types';

/** Application-wide defaults for layout selection. */
export interface LayoutConfig {
  defaultLayout: LayoutId;
}

/** Injection token that holds global layout defaults for the current app. */
export const LAYOUT_CONFIG = new InjectionToken<LayoutConfig>('LAYOUT_CONFIG', {
  factory: () => ({
    defaultLayout: 'default',
  }),
});
